<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#collection" @click="() => {selected = 'labelCompletes'; paginate('')}" data-toggle="tab">
                {{'summary' | translate}}
              </a>
            </li>
            <li>
              <a href="#single" data-toggle="tab" @click="() => {selected = 'labelIndividuals'; paginate('')}">
                {{'individual' | translate}}
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="active tab-pane" id="collection">
              <div class="box-controls" style="margin: -1em -1.5em 1em -1.5em;">
                <div class="row pagination-box">
                  <div class="col-md-3 col-sm-6">
                    <div class="input-group">
                      <div class="input-group-addon">
                        {{'month' | translate}}
                      </div>
                      <vue-monthly-picker
                        dateFormat="MM-YYYY"
                        class="form-control"
                        v-model="selectedMonthComplete"
                        @selected="paginate('', 'date')"
                        :max="max"
                        :monthLabels="monthLabels"
                      >
                      </vue-monthly-picker>
                    </div>
                  </div>
                  <b-btn @click="clear" type="button" class="btn btn btn-sm btn-warning">
                    <i class="fa fa-undo mr-5"></i>{{'reset_filters' | translate}}
                  </b-btn>
                  <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-3 col-sm-6">
                    <a target="_blank" href="/static/img/qb-csv-download.pdf" class="btn btn-info">
                      <i class="fa fa-cloud-download mr-5"></i>{{'csv_instructions' | translate}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="box-content">
                <shipcloud-table
                  :type="'notsingle'"
                  :language="$store.getters.language"
                  :items="paginationCollection.data" @sort="sort($event)"
                  @store="($event) => {selectedStore = $event; paginate('', 'store')}"
                >
                </shipcloud-table>
              </div>
            </div>
            <div class="tab-pane" id="single">
              <div class="box-controls" style="margin: -1em -1.5em 1em -1.5em;">
                <div class="row pagination-box">
                  <div class="col-md-3 col-sm-6">
                    <div class="input-group">
                      <div class="input-group-addon">
                        {{'month' | translate}}
                      </div>
                      <vue-monthly-picker
                        dateFormat="MM-YYYY"
                        class="form-control"
                        v-model="selectedMonth"
                        @selected="paginate('', 'date')"
                        :max="max"
                        :monthLabels="monthLabels"
                      >
                      </vue-monthly-picker>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6">
                    <select v-model="selectedStore" class="form-control" @change="paginate('', 'store')">
                      <option value="" class="form-control normal">
                        {{'all' | translate}}
                      </option>
                      <option class="form-control normal" v-for="item in $store.getters.stores" :value="item.id">
                        {{item.name}}
                      </option>
                    </select>
                  </div>
                  <b-btn @click="clear" type="button" class="btn btn btn-sm btn-warning">
                    <i class="fa fa-undo mr-5"></i>{{'reset_filters' | translate}}
                  </b-btn>
                  <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-3 col-sm-6">
                    <a target="_blank" href="/static/img/qb-csv-download.pdf" class="btn btn-info">
                      <i class="fa fa-cloud-download mr-5"></i>{{'csv_instructions' | translate}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="box-content">
                <shipcloud-table
                  :type="'single'"
                  :language="$store.getters.language"
                  :items="pagination.data"
                  @sort="sort($event)"
                  @store="($event) => {selectedStore = $event; paginate('', 'store')}"
                >
                </shipcloud-table>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="loading">
      <img class="loading-gif" src="/static/img/blabla.svg"/>
    </div>
  </section>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
export default {
  name: 'shipcloudLabels',
  data () {
    return {
      selected: 'labelCompletes',
      loading: false,
      sortType: 'desc',
      selectedStore: '',
      selectedMonth: moment().subtract(1, 'month'),
      selectedMonthComplete: moment().subtract(1, 'month'),
      max: moment(),
      monthLabels: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      paginationCollection: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      }
    }
  },
  components: {
    VueMonthlyPicker: VueMonthlyPicker
  },
  methods: {
    sort (type) {
      this.sortType = type
      this.paginate('', '')
    },
    clear () {
      if (this.selected === 'labelCompletes') {
        this.selectedMonthComplete = moment().subtract(1, 'month')
      } else {
        this.selectedMonth = moment().subtract(1, 'month')
        this.selectedStore = ''
      }
      this.paginate('clean', '')
    },
    paginate (type, value = '') {
      let use = this.selected === 'labelCompletes' ? 'paginationCollection' : 'pagination'
      let url = ''
      if (type !== 'clean') {
        url = '?'
        url += '&page='
        if (value === 'previous') {
          url += (this[use].current_page - 1)
        }
        if (value === 'next') {
          url += this[use].current_page >= this[use].last_page ? this[use].last_page : (this[use].current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
        url += `&date=${(use === 'pagination' ? this.selectedMonth : this.selectedMonthComplete).format('YYYY-MM')}`
        url += '&store_id=' + this.selectedStore
        url += '&sort_date=' + this.sortType
      }
      API.get(`download/${this.selected}${url}`)
        .then(response => {
          this[use] = response.data
        })
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get(`download/${this.selected}?sort_date=desc`)
          .then(response => {
            this.selected === 'labelCompletes' ? this.paginationCollection = response.data : this.pagination = response.data
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .picker:not(.month-year-label) {
    background: #212228;
  }
  .picker > .flexbox:not(.monthItem) {
    background-color: rgba(0,195,150,.075);
    border-color: #00C396;
    color: #00C396;
    font-weight: 600;
  }
  .picker > .flexbox.monthItem {
    background-color: #212228 ;
    color: white;
    font-weight: 600;
    border-top: 1px solid rgba(255,255,255, .15) !important;
  }
  .picker .monthItem .item:hover {
    background-color: #00C396 !important;
  }
  .date-popover{
    background: none !important;
    border: 1px solid rgba(255,255,255, .15) !important
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/ShipcloudLabels.vue